export const setCookie = ( name, value, daysToExpiry = 0 ) => {
  const cookieElements = [`${ name }=${ JSON.stringify( value ) }`]

  if ( daysToExpiry ) {
    const date = new Date()
    date.setDate( date.getDate() + daysToExpiry )
    cookieElements.push( `expires=${ date.toUTCString() }` )
  }

  cookieElements.push( 'path=/' )
  document.cookie = cookieElements.join( ';' )
}

export const getCookie = ( name ) => {
  var value = `; ${ document.cookie }`
  var parts = value.split(`; ${ name }=`)

  if ( parts.length > 1 ) {
    const cookieValue = parts.pop().split( ';' ).shift()

    if ( cookieValue ) {
      return JSON.parse( cookieValue )
    }
  }

  return null
}

export const removeCookie = ( name, { domain, path } ) => {
  document.cookie = `${ name }=;${ path ? ` path=${ path };` : '' }${ domain ? ` domain=${ domain };` : '' } Max-Age=-99999999;`
}